import { call, put, takeLatest, takeEvery,select } from 'redux-saga/effects';
import { FETCH_ORDERS_SUCCESS, FETCH_ORDERS_FAILURE, FETCH_ORDERS_REQUEST } from '../actions/orderActions';
import Axios from '../../utils/axiosInstance';



const API_URL = process.env.REACT_APP_API_BASE_URL;
const selectAuthToken = (state) => state.auth.token;
function* getAuthHeader(){
  const token = yield select(selectAuthToken)
   const authHead = {
    crossDomain: true,
    headers: {
      'Authorization': `Bearer ${token.access}`,
      //'content-type': 'multipart/form-data; boundary=----WebKitFormBoundarydZ6jmQ1T03hYxfyV'

    },
    withCredentials: true, // Enable credentials for this specific request
    
  }
  return authHead;
}

function* fetchOrdersApi(page) {
    try{
    const response = yield call(Axios.get,`${API_URL}shipment/my_orders?page=${page}&page_size=10`, yield call(getAuthHeader));
    //const { results: orders, count: totalBlogs } = response.data;
      return response.data; 

    }catch(error){
        console.log(error)
    }
    
  }

function* fetchOrdersSaga(action) {
  try {
    const { page } = action.payload;
    const data = yield call(fetchOrdersApi,page) //yield call(fetchOrdersApi, page);
    yield put({
        type: FETCH_ORDERS_SUCCESS,
        payload: {
          orders: data.results,
          totalPages: Math.ceil(data.count/10), // or use the correct fields from `data`
        },
      });
  } catch (error) {
    yield put({
        type: FETCH_ORDERS_FAILURE,
        payload: error.message,
      });
  }
}

export function* watchFetchOrders() {
    yield takeLatest(FETCH_ORDERS_REQUEST, fetchOrdersSaga);

  }
  
  export default watchFetchOrders;